import { useState, useCallback } from "react";
import { chatApi } from "../api/ChatApi";
import { useAuth } from "../context/AuthContext";

interface UseEnhancePromptResult {
  enhancing: boolean;
  enhance: (prompt: string) => Promise<string | null>;
}

// Centralizes enhance prompt API interaction & token handling
export function useEnhancePrompt(): UseEnhancePromptResult {
  const { getAccessToken } = useAuth();
  const [enhancing, setEnhancing] = useState(false);

  const enhance = useCallback(async (prompt: string) => {
    const trimmed = (prompt || "").trim();
    if (!trimmed) return null;
    if (enhancing) return null;
    setEnhancing(true);
    try {
      const token = await getAccessToken();
      const resp = await chatApi.enhancePrompt(trimmed, token || undefined);
      const enhanced: string =
        resp?.enhanced_prompt || resp?.prompt || resp?.result || resp?.data || trimmed;
      return typeof enhanced === "string" && enhanced.trim() ? enhanced : trimmed;
    } catch (e) {
      return null;
    } finally {
      setEnhancing(false);
    }
  }, [getAccessToken, enhancing]);

  return { enhancing, enhance };
}

export default useEnhancePrompt;
